module.exports = __webpack_public_path__ + "images/emoji/clock6.1be0490c06fb38ddf120.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock6.png
// module id = p5J6
// module chunks = 24